/* eslint-disable react/prop-types */
import { Tab as MuiTab, Tabs as MuiTabs } from '@material-ui/core';
import React from 'react';

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

export const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <>{children}</>}
    </div>
  );
};

/**
 * Tabs Component.
 * tabs: is Array of tab, defined below
 * !Array<{label:string|node,icon:node,value:string|number...tabProps}>
 * tabProps: is props types of MUI TAB (https://material-ui.com/api/tab/)
 * tabsProps: is props types of  MUI TABS. (https://material-ui.com/api/tabs/)
 * @param {*} param0
 */
export const Tabs = ({
  currentTab,
  defaultActive,
  tabs,
  onChangeTab,
  tabPanelClassName,
  renderTab,
  disabled,
  ...tabsProps
}) => {
  const [activated, setActivated] = React.useState(defaultActive || 0);

  React.useEffect(() => {
    setActivated(currentTab);
  }, [currentTab]);
  const onChange = (event, newValue) => {
    if (disabled) return;
    setActivated(newValue);
    if (onChangeTab) {
      onChangeTab(newValue);
    }
  };

  return (
    <>
      <MuiTabs {...tabsProps} value={activated} onChange={onChange}>
        {tabs.map(({ label, value, content, ...tabProp }, index) => {
          if (renderTab) {
            return renderTab({
              label,
              value,
              index,
              disabled,
              ...tabProp,
              ...a11yProps(value || index),
            });
          }
          return (
            <MuiTab
              key={value || index}
              label={label}
              {...a11yProps(value || index)}
              {...tabProp}
            />
          );
        })}
      </MuiTabs>
      {tabs.map(({ label, value, content: children, ...tabProp }, index) => (
        <TabPanel
          key={value || index}
          value={activated}
          index={index}
          label={label}
          className={tabPanelClassName}
          {...tabProp}>
          {children}
        </TabPanel>
      ))}
    </>
  );
};
